import { AcModel } from 'projects/core/src/lib/models/ac.model';
import { Deserializable } from 'projects/core/src/lib/models/deserializable';
import { ExercisepartModel } from 'projects/core/src/lib/models/exercisepart.model';
import { SlotModel } from 'projects/core/src/lib/models/slot.model';
import * as moment from 'moment';
import { OnlinetestModel } from 'projects/core/src/lib/models/onlinetest.model';
import { CandidateOnlinetestModel } from 'projects/core/src/lib/models/candidate-onlinetest.model';

export class EditslotModel implements Deserializable {

  // relations
  ac: AcModel = null;
  slot: SlotModel = null;
  exercisepart: ExercisepartModel;
  onlinetest: CandidateOnlinetestModel;

  errors: Array<string> = [];
  pseudo_start_time: any = null;
  showReorderHandle = true;

  deserialize(input: any): this {
    Object.assign(this, input);
    // ac
    if (this.ac !== null && this.ac !== undefined) {
      this.ac = new AcModel().deserialize(this.ac);
    }
    // slot
    if (this.slot !== null && this.slot !== undefined) {
      this.slot = new SlotModel().deserialize(this.slot);
    }
    // exercisepart
    if (this.exercisepart !== null && this.exercisepart !== undefined) {
      this.exercisepart = new ExercisepartModel().deserialize(this.exercisepart);
    }
    // onlinetest
    if (this.onlinetest !== null && this.onlinetest !== undefined) {
      this.onlinetest = new CandidateOnlinetestModel().deserialize(this.onlinetest);
    }
    return this;
  }

  public get type(): string {
    return this.slot.type;
  }

  public get icon(): string {
    return this.slot.icon;
  }

  public get name(): string {
    const exercisepart: any = {...this.exercisepart};
    let exercise_name = exercisepart?.exerciseversion?.exercise?.title;
    return ((exercise_name) ? exercise_name + ': ' : '') + (this.slot.name || this.exercisepart?.name || '');
  }

  public get start_time(): number {
    return this.slot.start_time;
  }

  public get duration(): number {
    return this.slot.duration || this.exercisepart?.duration;
  }

  public get ratingGap(): number {
    let gap = 0;
    if (this.exercisepart !== undefined && this.exercisepart !== null) {
      if (this.exercisepart.rating_start === 'start') {
        gap = Math.max(this.exercisepart.duration, this.exercisepart.rating_duration) - this.exercisepart.duration;
      } else if (this.exercisepart.rating_start === 'end') {
        gap = this.exercisepart.rating_duration; // @todo Onlinetest
      }
    } else if (this.onlinetest !== undefined && this.onlinetest !== null) {
      gap = this.onlinetest.rating_duration;
    }
    return gap;
  }

  public get for_candidate(): boolean {
    return this.slot.for_candidate || this.exercisepart?.for_candidate;
  }

  public get for_observer(): boolean {
    return this.slot.for_observer || this.exercisepart?.for_observer;
  }

  public get time_real(): any {
    const time = (this.ac.start_time_admin) ? this.ac.start_time_admin : this.pseudo_start_time;
    return (time) ? moment(time).add(this.start_time, 'minutes') : null;
  }

  public get time_minutes(): any {
    return this.start_time;
  }

  public setData(data: any): void {
    switch (this.slot.type) {
      case ('break'): {
        this.slot.duration = parseInt(data.duration, 10);
        this.slot.for_candidate = data.relevance?.for_candidate;
        this.slot.for_observer = data.relevance?.for_observer;
        break;
      }
      case ('conference'):
      case ('exercisepart'): {
        this.slot.start_time = parseInt(data.start_time, 10);
        this.slot.duration = parseInt(data.duration, 10);
        break;
      }
      default: {
        this.slot.name = data.name;
        this.slot.start_time = parseInt(data.start_time, 10);
        this.slot.duration = parseInt(data.duration, 10);
        this.slot.for_candidate = data.relevance?.for_candidate;
        this.slot.for_observer = data.relevance?.for_observer;
        break;
      }
    }
  }

  public setPseudoStarttime(time: any): void {
    this.pseudo_start_time = time;
  }

  public getEndTimeAsMinutes(mode: string | null = null): number { // @mode: candidate | observer
    return this.start_time + this.duration;
  }

  public hasError(type: string): boolean {
    return this.errors.indexOf(type) !== -1;
  }

}
